import { render, staticRenderFns } from "./MicrocopySocialInputsForm.vue?vue&type=template&id=69a0a17e"
import script from "./MicrocopySocialInputsForm.vue?vue&type=script&lang=js"
export * from "./MicrocopySocialInputsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports